import {Solutions} from '../../app/models/environment-configuration';

const MINUTES_45 = 2700000;
const MINUTES_20 = 1200000;
export const linkIconThreshold = {
  warning: MINUTES_20,
  critical: MINUTES_45
};

export const ALLEANZA_COMMON_ENV = {
  SOLUTION: Solutions.ALLEANZA,
  LINK_THRESHOLD: linkIconThreshold,
  isFindAPortEnabled: false
};

